import Disease from "./Disease";

export default Disease;